export default "__VITE_ASSET__DJWiOyG3__"